export default __webpack_public_path__ + "static/raoufDridi@2x-64572c85adf70fe4aab99ca67df4c56c.jpg";